import { getIssueKey } from '@atlassian/jira-router-resources-utils/src/utils/get-issue-key/index.tsx';
import { createResource } from '@atlassian/react-resource-router';
import { withResourceEarlyData } from '../../utils.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const issueMediaUploadPermissionResource = createResource<any>(
	withResourceEarlyData({
		type: 'ISSUE_MEDIA_UPLOAD_PERM',
		getKey: ({ match }) => {
			const issueKey = getIssueKey(match);
			return issueKey || '';
		},
		getData: () => null,
		isBrowserOnly: true,
	}),
);
